import { type SimpleQuery } from '@pkg/types';

import { formatParams } from '@app/client/common/api';

export interface UseQueryStringParams {
    queryArrayKey?: string;
    queryArray?: string[];
    queryParams?: SimpleQuery;
}

// TODO: Considering moving to API directory if not DAAS v2 specific.
export function getQueryString({ queryArrayKey, queryArray, queryParams }: UseQueryStringParams) {
    const queries = formatParams(queryParams);
    let queryString = `?${queries}`;

    if (queryArrayKey && queryArray?.length) {
        const arrayString = queryArray?.join(`&${queryArrayKey}=`);
        const queryArrayString = `?${queryArrayKey}=${arrayString}`;
        queryString = `${queryArrayString}${queries ? `&${queries}` : ''}`;
    }

    return queryString;
}
